module.exports = __webpack_public_path__ + "static/media/user.86f2dc29.svg";